module.exports = __webpack_public_path__ + "static/img/200_TO8_2104.27c1d7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/200_TO8_2104.jpg
// module id = Bryx
// module chunks = 0